import React, { useState } from "react";

const Error = (props) => {
    return <div className="plz-error">
        <button className="btn-plz-error-close" onClick={()=>props.setShowError(false)}>
            <span className="new-icons-close"></span>
            <span className="sr-only">Schließen</span>
        </button>
        <p>Vielen Dank für Ihr Interesse an unseren Produkten.</p>
        <p dangerouslySetInnerHTML={{__html: props.errorText}}></p>
    </div>
}

export default Error;